
import { Box,Flex, FlexboxProps, HStack,Text, VStack } from '@chakra-ui/react'
import { VehicleType } from 'context/types'
import { themeColors } from 'theme'

import { CarIcon } from 'components/SVGS'

interface VehicleInformationProps {
  vehicle?: VehicleType;
  isCarrouselComponent?: boolean;
  isCenter?: boolean;
  flexDir?: FlexboxProps['flexDir'];
  plateNumber?: string;
  isOnline:boolean | null;
  mileage?: number;
}

const VehicleInformation: React.FC<VehicleInformationProps> = ({
  vehicle,
  isCenter = false,
  plateNumber,
  flexDir,
  isOnline = null,
  mileage = undefined
}) => {
  const {
    drawer: { bgActiveColor },
    text: { bgPressedText },
  } = themeColors



  return (
    <VStack justifyContent={'start'} alignContent={'start'}>
      <HStack
        {...isCenter && { w: 'full', justifyContent: 'center', alignItems: 'center', h: 'fit-content' }}
        flexDir={flexDir}>
        {vehicle ? (
          <HStack spacing={4} px={2} wrap={'wrap'} justify="center" >
            <VStack spacing={0}>
              <HStack>
                <CarIcon size={12} />
                <Text variant='MD_SB'>{vehicle.model}</Text>
              </HStack>
            </VStack>
            <Flex bg={bgActiveColor} p={2} px={3} rounded='3xl'>
              <Text variant='MD_SB' color={bgPressedText}>
                {vehicle.plateNumber}
              </Text>
            </Flex>
            <HStack>
             { mileage !== undefined  && <Flex bg='white' rounded='8px' alignItems="center" justifyContent='center' p={0} px={2} py={1}>
                <VStack spacing={0} justifyContent={'center'} alignItems={'center'} >
                    <Text variant="MD_SB" fontSize={'sm'} fontWeight={'light'} color={'black'} >
                      Kilometraje
                    </Text>
                    <Text variant="MD_SB" color='black' fontSize='xl'>
                    { mileage ? new Intl.NumberFormat('es-CL').format(mileage) : 'Cargando ...'}
                    </Text>
                </VStack>
              </Flex>}
              {isOnline !== null &&
                <Flex
                  alignItems="center"
                  bg={isOnline ? '#01A06B' : '#EC494E'}
                  p={2} px={3}
                  rounded="3xl"
                >
                  <Box width="8px" height="8px" bg={isOnline ? 'green.200' : 'red.200'} rounded="full" mr={2} />
                  <Text variant='MD_SB'>
                    {isOnline ? 'En línea' : 'Fuera de línea'}
                  </Text>
                </Flex>
              }
            </HStack>
        </HStack>

  ) : (
          <Flex bg={bgActiveColor} p={2} px={3} rounded='3xl'>
            <Text variant='MD_SB' color={bgPressedText}>
              {plateNumber}
            </Text>
          </Flex>
        )}
        </HStack>
    </VStack>
  )
}

export default VehicleInformation
